import React from 'react';
import useResortSnowReport from "../hooks/useResortSnowReport";
import FlexibleSnowReport from "./FlexibleSnowReport";
import LoadingIndicator from "./LoadingIndicator";

export function SnowReport({dataID}) {
    const {scrappedReport, isLoading} = useResortSnowReport({dataID});

    if (isLoading) {
        return <LoadingIndicator height={50}/>
    }
    return (
        <FlexibleSnowReport report={scrappedReport}/>
    )
}

export function GroundReport({dataID}) {
    const {scrappedReport, isLoading} = useResortSnowReport({dataID});

    if (isLoading) {
        return <LoadingIndicator height={50}/>
    }
    return (
        <div dangerouslySetInnerHTML={{__html: scrappedReport.conditions[0].report}}></div>
    )
}